import axios from 'axios'

const getDefaultState = () => {
  return {
    data: []
  }
}

const state = getDefaultState()

const actions = {
  fetchPaymentHistory ({ commit }) {
    return axios.get('payment').then(response => {
      commit('setPaymentHistory', response.data.payload)
    })
  }
}

const mutations = {
  setPaymentHistory (state, payload) {
    state.data = payload
  }
}

const getters = {
  getPaymentHistory: (state) => {
    return state.data
  },

  getLastPayment: (state) => {
    if (!state.data.length) return null

    return state.data[0]
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
